// extracted by mini-css-extract-plugin
module.exports = {"wrap":"StudentPoint_wrap__14fve","heading":"StudentPoint_heading__1e8g4","image":"StudentPoint_image__36dMB"};